var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossPreventionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 27.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #555252;\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_210729784",
    "data-name": 210729784
  }, /*#__PURE__*/React.createElement("path", {
    id: "_213155904",
    "data-name": 213155904,
    className: "cls-1",
    d: "M2.42,11.19C1.09,11.19,0,10.12,0,8.81v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,.94.79,1.7,1.77,1.7s1.77-.76,1.77-1.7v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,1.32-1.09,2.39-2.42,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155880",
    "data-name": 213155880,
    className: "cls-1",
    d: "M6.62,11.19c-1.34,0-2.42-1.07-2.42-2.39v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,.94.79,1.7,1.77,1.7s1.77-.76,1.77-1.7v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,1.32-1.09,2.39-2.42,2.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155808",
    "data-name": 213155808,
    className: "cls-1",
    d: "M10.81,11.19c-1.34,0-2.42-1.07-2.42-2.39v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,.94.79,1.7,1.77,1.7s1.77-.76,1.77-1.7v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,1.32-1.09,2.39-2.42,2.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155856",
    "data-name": 213155856,
    className: "cls-1",
    d: "M15,11.19c-1.34,0-2.42-1.07-2.42-2.39v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,.94.79,1.7,1.77,1.7s1.77-.76,1.77-1.7v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,1.32-1.09,2.39-2.42,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155352",
    "data-name": 213155352,
    className: "cls-1",
    d: "M19.19,11.19c-1.34,0-2.42-1.07-2.42-2.39v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,.94.79,1.7,1.77,1.7s1.77-.76,1.77-1.7v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,1.32-1.09,2.39-2.42,2.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155472",
    "data-name": 213155472,
    className: "cls-1",
    d: "M23.38,11.19c-1.34,0-2.42-1.07-2.42-2.39v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,.94.79,1.7,1.77,1.7s1.77-.76,1.77-1.7v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,1.32-1.09,2.39-2.42,2.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155592",
    "data-name": 213155592,
    className: "cls-1",
    d: "M27.58,11.19c-1.34,0-2.42-1.07-2.42-2.39v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,.94.79,1.7,1.77,1.7s1.77-.76,1.77-1.7v-.19c0-.19.15-.34.33-.34s.33.15.33.34v.19c0,1.32-1.09,2.39-2.42,2.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155256",
    "data-name": 213155256,
    className: "cls-1",
    d: "M27.96,27.83H2.04c-.18,0-.33-.15-.33-.34V10.81c0-.19.15-.34.33-.34s.33.15.33.34v16.34h25.26V10.81c0-.19.15-.34.33-.34.18,0,.33.15.33.34v16.68c0,.19-.15.34-.33.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155112",
    "data-name": 213155112,
    className: "cls-1",
    d: "M1.16,2.33h27.67V.68H1.16v1.65ZM29.16,3.02H.84c-.18,0-.33-.15-.33-.34V.34c0-.19.15-.34.33-.34h28.33c.18,0,.33.15.33.34v2.33c0,.19-.15.34-.33.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155376",
    "data-name": 213155376,
    className: "cls-1",
    d: "M29.67,8.96c-.13,0-.26-.09-.31-.23l-2.03-5.95c-.06-.18.03-.37.2-.44.17-.06.36.03.42.21l2.03,5.95c.06.18-.03.37-.2.44-.04.01-.07.02-.11.02h0ZM.33,8.96s-.07,0-.11-.02c-.17-.06-.26-.26-.2-.44L2.05,2.56c.06-.18.25-.27.42-.21.17.06.26.26.2.44L.64,8.73c-.05.14-.17.23-.31.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155640",
    "data-name": 213155640,
    className: "cls-1",
    d: "M17.96,22.58h-6.1c-.15,0-.28-.1-.32-.25l-1.79-7h-1.05c-.18,0-.33-.15-.33-.34,0-.19.15-.34.33-.34h1.3c.15,0,.28.1.32.25l1.79,7h5.85c.18,0,.33.15.33.34,0,.19-.15.34-.33.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_213155616",
    "data-name": 213155616,
    className: "cls-1",
    d: "M17.96,22.58h-6.1c-.15,0-.28-.1-.32-.25l-1.79-7h-1.05c-.18,0-.33-.15-.33-.34s.15-.34.33-.34h1.3c.15,0,.28.1.32.25l1.79,7h5.85c.18,0,.33.15.33.34s-.15.34-.33.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_210729280",
    "data-name": 210729280,
    className: "cls-1",
    d: "M17.7,20.98h-6.17c-.18,0-.33-.15-.33-.34,0-.19.15-.34.33-.34h5.91s.94-4.32.94-4.32c0-.03-.09-.1-.2-.1h-7.95c-.18,0-.33-.15-.33-.34s.15-.34.33-.34h7.95c.27,0,.54.13.7.34.13.18.18.39.14.59l-.99,4.59c-.03.16-.17.27-.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_210731536",
    "data-name": 210731536,
    className: "cls-1",
    d: "M17.7,20.98h-6.17c-.18,0-.33-.15-.33-.34s.15-.34.33-.34h5.91s.94-4.32.94-4.32c0-.03-.09-.1-.2-.1h-7.95c-.18,0-.33-.15-.33-.34s.15-.34.33-.34h7.95c.27,0,.54.13.7.34.13.18.18.39.14.59l-.99,4.59c-.03.16-.17.27-.32.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_210729520",
    "data-name": 210729520,
    className: "cls-1",
    d: "M13.01,23.26c-.16,0-.29.13-.29.3,0,.17.13.3.29.3s.29-.13.29-.3c0-.17-.13-.3-.29-.3h0ZM13.01,24.55c-.52,0-.94-.44-.94-.99s.42-.99.94-.99c.52,0,.94.44.94.99,0,.54-.42.99-.94.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_210729928",
    "data-name": 210729928,
    className: "cls-1",
    d: "M13.01,23.26c-.16,0-.29.13-.29.3s.13.3.29.3.29-.13.29-.3-.13-.3-.29-.3h0ZM13.01,24.55c-.52,0-.94-.44-.94-.99s.42-.99.94-.99c.52,0,.94.44.94.99s-.42.99-.94.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_210730144",
    "data-name": 210730144,
    className: "cls-1",
    d: "M16.86,23.27c-.16,0-.29.13-.29.3,0,.17.13.3.29.3s.29-.13.29-.3c0-.17-.13-.3-.29-.3ZM16.86,24.56c-.52,0-.94-.44-.94-.99,0-.54.42-.99.94-.99.52,0,.94.44.94.99s-.42.99-.94.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_210730072",
    "data-name": 210730072,
    className: "cls-1",
    d: "M16.86,23.27c-.16,0-.29.13-.29.3s.13.3.29.3.29-.13.29-.3-.13-.3-.29-.3ZM16.86,24.56c-.52,0-.94-.44-.94-.99s.42-.99.94-.99c.52,0,.94.44.94.99s-.42.99-.94.99Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossPreventionIcon);
export default __webpack_public_path__ + "static/media/loss-prevention-icon.54589afe5a6bb8125b4f3c354c26a125.svg";
export { ForwardRef as ReactComponent };